import React, { useEffect, useState } from "react";
import axios from "axios";
import { dashboardURL } from "../../Config/Url";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";
import WhiteLoader from "../Common/WhiteLoader";

import {formatUtcToDate} from "../../Helpers/DateHelper";
const DailyInvoiceNumber = () => {
  const [dailyInvoiceCount, setDailyInvoiceCount] = useState(5);
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingNum, setIsLoadingNum] = useState(false);
 const currentDate = new Date();
  let config = {
    headers: {
      "X-IsMockup": false,
      "X-Tenantid": +localStorage.getItem("tenantId"),
    },
  };

 useEffect(() => {
    axios
      .get(`${dashboardURL}/daily-total-count`, config)
      .then((result) => {
        setDailyInvoiceCount(result.data.total);
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
    
  }, []);

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
          <Card.Body className="dashboard-card-body-tenant">
            <div className="dashboard-card-body-tenant-image">
              <span
                className="icon icon-target"
                style={{ fontSize: 40 }}
              ></span>
            </div>
            <div className="dashboard-card-body-tenant-simpleData">
              {isLoading ? <WhiteLoader /> : dailyInvoiceCount} 
            </div>
          </Card.Body>
          <Card.Footer className="dashboard-card-footer-tenant">
            {translator("Dashboard-DailyInvoiceCount-Title")} <br/>  {formatUtcToDate(currentDate.toString())}
          </Card.Footer>
        </>
      )}
    </>
  );
};

export default DailyInvoiceNumber;
